<template>
  <transition name="el-fade-in-linear">
    <div class="joinDetail">
      <router-link to="/join">
        <img class="joinbackPic" src="../../static/images/back.png" />
      </router-link>
      <div class="jobContent">
      <div class="joinDetailTitle">{{job.jobTitle}}</div>
      <div class="joinDetailTitleLittle">{{job.joinTitleLittle}}</div>
      <div class="line"></div>
      <div class="sencondTitle">岗位职责:</div>
      <div class="sencondText" v-for="(item, index) in job.firstText" :key="index">
        <p>{{item}}</p>
      </div>
      <div class="sencondTitle">任职要求:</div>
      <div class="sencondText" v-for="(item, index) in job.secondText" :key="index+'77'">
        <p>{{item}}</p>
      </div>
      </div>

      <div class="layoutFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {
      job: {
        jobTitle: "",
        joinTitleLittle: "",
        firstText: "",
        secondText: "",
         page:"",
      },
    };
  },
  components: {
    Foot,
  },
  mounted: function () {
    let data = {
      jobTitle: [
        "产品经理（员工&实习）",
        "项目经理（员工&实习）",
        "解决方案经理",
        "大数据工程师",
        "数据分析工程师",
        "高级销售经理",
        "图像算法实习生",
      ],
      joinTitleLittle: [
        "工作地点：深圳市",
        "工作地点：深圳市",
        "工作地点：深圳市",
        "工作地点：深圳市",
        "工作地点：深圳市",
        "工作地点：深圳市",
        "工作地点：深圳市",
      ],
      firstText: [
        [
          "- 负责智能交通产品的研发及产品开发过程管理工作",
          "- 负责与甲方对接产品需求，撰写PRD文档，对需求变更进行评估和控制，解决需求痛点问题，输出产品原型设计",
          "- 负责与相关部门协调推进项目执行，组织具体项目实施，把控项目实施的质量和效率",
          "- 关注市场数据、用户调研与反馈，持续优化产品，推动产品交互体验提升",
        ],
        [
          "- 负责智能交通产品的研发及项目管理工作，对项目的开发流程、项目质量和开发进度进行规划和管理",
          "- 协调项目资源，制定项目计划，对于项目中的变更进行评估和控制，建立合理的业务迭代规划，解决项目痛点问题",
          "- 负责与相关部门沟通协调推进项目执行，负责与技术团队一同规划、建设开发流程",
          "- 安排项目组日常工作，协调团队开发，定期向分管领导汇报工作；及时跟进项目问题风险",
        ],
        [
          "- 面向大型交通企业以及政府提供项目的前期方案讲解与需求调研和立项工作",
          "- 根据公司产品部的解决方案提供面向客户的市场化包装与推广",
          "- 梳理行业客户需求，寻找机会点，撰写产品解决方案推动销售",
          "- 面向地铁、机场、公安提供大数据可视化系统软件的展示和推广，协助和配合销售完成销售任务",
          "- 协同商务、技术共同完成标书制作等投标工作",
          "- 对区域市场和竞争对手进行调研，制定和优化公司的市场推广方案，并评估改进",
        ],
        [
          "- 负责常规的数据清洗、分析和存储",
          "- 负责分布式计算和实时计算的模块开发",
          "- 负责模型部署、测试、实施及模型应用效果监控工作，进行模型调优与维护",
          "- 负责人物画像系统的设计与搭建",
        ],
        [
          "- 从事智慧城市、智能交通大数据相关的软件产品和工具的研发，涵盖数据采集、接入、清洗、分析、挖掘各个阶段",
          "- 负责公司大数据模块化平台的搭建与优化工作",
          "- 负责海量数据采集、接入、清洗、分析、挖掘的代码实现",
          "- 负责建立并完善的数据分析挖掘流程及体系",
        ],
        [
          "- 充分掌握公司业务以及行业特点，并根据行业市场现状和发展趋势把握销售方向，挖掘客户需要，开发新客戶",
          "- 根据公司的销售计划，制定销售策略，负责公司产品的销售工作并实现销售目标",
          "- 协助技术开发部门与客户进行技术交流和沟通，深度挖掘客户的内在需求并协调资源，为客户提供满意的解决方案",
          "- 跟踪项目进度，协调项目各方，推动项目顺利验收并加快项目验收进度，确保项目计划的完成以及销售款项的收回",
          "- 与产品部门紧密合作，提出产品开发需求，并协助反馈与完善",
          "- 与客户保持长期良好的合作关系，了解客户的衍生需求，推进系统的更新和升级",
        ],
        [
          "- 参与计算机视觉核心算法（人脸识别、人群计数、行为识别等但不限于）的研发，以及深度学习核心算法（CNN、RNN、GAN等）的研发",
        ],
      ],
      secondText: [
        [
          "- 全日制本科及以上学历，有B端软件开发业务背景，交通领域相关的工作经验，对项目管理有一定了解",
          "- 熟练使用Axure、XMind、Visio、PPT等工具，独立进行的产品设计文档撰写；对系统易用性设计和用户体验有良好的直觉，注重细节",
          "- 善于发现问题、解决问题，具有较强的策划能力",
          "- 抗压能力强，具有解决冲突矛盾的能力，较强的团队协作能力",
          "- 工作热情，责任心强，有较强的开拓创新精神",
        ],
        [
          "- 全日制本科及以上学历，交通或计算机相关专业，有交通领域相关的工作经验，对项目管理专业知识有一定了解",
          "- 熟练使用Axure、XMind、Visio、PPT等工具，独立进行的产品设计文档撰写",
          "- 具备优秀的沟通表达能力，学习总结能力和逻辑思维能力",
          "- 抗压能力强，具有解决冲突矛盾的能力，较强的团队协作能力",
          "- 工作热情，性格坚毅，有较强的开拓创新精神",
          "- 具有PMP，IPMP，PRINCE2，Scrum Muster，RDPM等相关资质认证的优先",
        ],
        [
          "- 本科以上学历，3年以上工作经验，有地铁、公安等领域安防相关的售前咨询工作经验",
          "- 有很好的沟通、学习能力及创新意识，具备一定的写作能力、管理能力、协调能力",
          "- 具备独立分析、判断、解决问题的能力，有一定的商务谈判和公关能力",
          "- 工作积极主动，责任心强，有团队合作精神，也有较强的抗压能力",
          "- 有较强的市场感知能力，敏锐地把握市场动态以及方向，可适应频繁出差",
        ],
        [
          "- 三年以上软件开发经验，本科及以上学历，计算机/通信/应用数学/自动化等相关专业",
          "- 熟悉JAVA/SCALA的开发，了解常规的JAVA底层原理；至少熟悉一门脚本语言(Shell/Python/Perl/R等)，对设计模式有一定理解和应用经验",
          "- 熟悉Hadoop/Spark或者其他分布式框架的开发(Storm/Flink)，有大规模并行计算/实时计算的开发经验",
          "- 熟悉分布式存储(HDFS等)，关系型存储(MySQL/PostgreSQL等)，非关系存储(HBase/Redis/ElasticSearch等)中至少一项或多项",
          "- 对数据足够敏感，具备严谨的逻辑分析和判断能力，能够结合对数据的分析解读，对复杂问题给出准确的判断和结论",
        ],
        [
          "- 两年以上软件开发工作经验，本科以上学历，计算机/数学等相关专业",
          "- 能熟练运用Java/Python/Scala/多种语言进行软件开发",
          "- 熟练掌握基本的算法和数据结构，熟练掌握至少一种主流关系型数据库的使用和开发，熟练掌握SQL语言，熟悉NoSQL和NewSQL数据库",
          "- 精通Hadoop、Storm、Spark、HBase、Flume、Kafka、ES等组件的原理，精通分布式系统开发，数据仓库技术",
          "- 对Hadoop平台架构能够不断优化，提升数据产品的质量和体验",
          "- 强烈的责任心与求知欲，对技术有极大的热情，有良好的沟通能力",
        ],
        [
          "- 大学本科及以上学历，计算机、市场营销、经济学、交通等相关专业",
          "- 三年以上IT行业销售工作经验；熟悉智慧城市、智慧交通相关行业；拥有B端互联网产品销售经验者优先考虑",
          "- 具有良好的沟通协调能力、语言表达能力、组织管理的能力",
          "- 拥有项目招投标经验、渠道销售经验以及大客户开发工作经验",
          "- 有责任心，抗压能力强，具有市场开拓精神，能接受频繁出差",
        ],
        [
          "- 全日制本科以上学历，计算机/数学/通信等相关专业",
          "- 熟悉深度学习常用的算法和优化策略，熟悉常用机器学习算法模型",
          "- 熟悉C/C++/Python/Matlab等至少一种编程语言；掌握TensorFlow、PyTorch、Caffe等一种或者几种深度学习框架，熟悉Linux工作环境，对数据结构和算法设计有深刻理解",
          "- 了解深度学习/计算机视觉领域的最新研究成果、公开数据集和相关的开源系统",
        ],
      ],
    };
    this.job.jobTitle = data.jobTitle[this.$route.query.index - 1];
    this.job.joinTitleLittle =
      data.joinTitleLittle[this.$route.query.index - 1];
    this.job.firstText = data.firstText[this.$route.query.index - 1];
    this.job.secondText = data.secondText[this.$route.query.index - 1];
  },
  methods: {
    goDetail () {
      //获取demo1页面的page值
       history.go(-1)

      // this.$router.push({
      //   path: "newsDetail",
      //   // query: {scrollTop:this.$route.query.scrollTop}
      // });
    },
  },
};
</script>
<style scoped>
@import "./JoinDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/JoinDetail.vue